import { forwardRef } from 'react';
import { Form, Dropdown } from 'react-bootstrap';
import { useOrganization } from '../context/OrganizationContext';
import { UserInvitation } from '../models/shared/UserInvitation';
import Gravatar from "./Gravatar";

interface Props {
    label?: string;
    error?: boolean;
    emptyLabel?: string;
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
    size?: 'sm' | 'lg';
    members?: UserInvitation[];
}

const OrgMemberSelect = forwardRef<HTMLButtonElement, Props>(
    ({ label, error, emptyLabel, value, onChange, disabled, size, members }, ref) => {
        const { members: orgMembers } = useOrganization();
        const selectableMembers = members || orgMembers || [];
        const baseContainerClassName = "d-flex align-items-center gap-2";
        const selectedUser = selectableMembers.find(m => m.email === value);

        return (
            <Form.Group>
                {label && (
                    <Form.Label className='fw-semibold'>{label}</Form.Label>
                )}
                <Dropdown>
                    <Dropdown.Toggle
                        ref={ref}
                        variant="outline-secondary"
                        size={size}
                        disabled={disabled}
                        className={`${error ? 'is-invalid' : ''} ${baseContainerClassName}`}
                    >
                        {selectedUser && (
                            <Gravatar
                                identifier={selectedUser.email}
                                size={size === 'sm' ? 'xxs' : 'xs'}
                                default="wavatar"
                            />
                        )}
                        {selectedUser?.email || emptyLabel}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {emptyLabel && (
                            <Dropdown.Item
                                onClick={() => onChange?.('')}
                                active={!value}
                                className={baseContainerClassName}
                            >
                                {emptyLabel}
                            </Dropdown.Item>
                        )}

                        {selectableMembers.map((m) => (
                            <Dropdown.Item
                                key={m.email}
                                onClick={() => onChange?.(m.email)}
                                active={m.email === value}
                                className={baseContainerClassName}
                            >
                                <Gravatar identifier={m.email} size="xs" default="wavatar" />
                                {m.email}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </Form.Group>
        );
    }
);

export default OrgMemberSelect;